import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dataSize',
})

export class DataSizePipe implements PipeTransform {
  transform(sizeInKB: number | null | undefined ):string {

		if(sizeInKB === null || sizeInKB === undefined || isNaN(sizeInKB)) return '-'

		const units = ['KB', 'MB', 'GB', 'TB']
		let size = sizeInKB
		let unit = 0

		while(size >= 1000 && unit < units.length - 1) {
			size /= 1000
			unit++
		}

		const formattedSize = Number.isInteger(size)? size.toString() : parseFloat(size.toFixed(2).toString())
		return `${formattedSize} ${units[unit]}`
  }
}